var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container"},[_c('div',{staticClass:"top"},[_c('TopMenu',{attrs:{"top":_vm.top}})],1),_c('div',{staticClass:"main"},[_c('router-view')],1),_c('div',{staticClass:"bottom"},[_c('BottomMenu')],1),_c('div',{staticClass:"contact-box"},[_c('Contact')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }